/* eslint-disable */
import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';

import { extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';

import ADVCakeService from '@/js/common/Domain/Service/ADVCake';
import fromRouterHydrator from '@/js/common/Domain/Hydrator/fromRouterRussia';
import toRouterHydrator from '@/js/common/Domain/Hydrator/toRouterRussia';
import ToursOnIndexView from '@fr/pages/desktop/travelata/travelata/toursOn/View/ToursOnIndex';
import AbstractSearchController from '@/js/desktop/Domain/Abstract/SearchController';
import SearchFormAutocompleteView from '@/js/desktop/components/searchFormAutocomplete/SearchFormAutocomplete';

import RestTypesRepository from './Domain/Repository/RestTypes';
import SubscribeForm from '../atlas/View/SubscribeForm';
import DirectionsRepository from './Domain/Repository/Directions';
import DestinationViewRussia from './View/Destination';

import template from './View/template.html';
import '@/css/desktop/search';
import '@/css/desktop/atlas/landing-destinations-header.scss';
import '@/css/desktop/atlas/landing-content.css';
import '@/css/desktop/atlas/landing-destinations-list.css';

@extendDecorator({
    view: null,
    fromRouterHydrator,
    toRouterHydrator,
})
class Controller extends AbstractSearchController {
    initSubscribeForm() {
        new SubscribeForm();
    }

    initSearchForm() {
        this.searchFormView = new SearchFormAutocompleteView({
            DestinationView: DestinationViewRussia
        });
    }

    initStaticController() {
        RestTypesRepository.repository.init(window.defaultRestTypes);

        DirectionsRepository.repository.init({
            directions: _.map(window.defaultDirections, (direction) => ({
                    link: direction.route,
                    cover: direction.cover,
                    title: direction.resort.name,
                    directionId: direction.resort.id,
                    restTypes: _.pluck(direction.restTypes, 'id'),
            })),
            prices: window.defaultResortPrices,
        });

        this.view = new ToursOnIndexView({
            directionsTemplate: template,
            RestTypesRepository,
            DirectionsRepository,
        });
    }

    initSearchFormController() {
        AbstractSearchController.prototype.initialize.call(this);
    }

    initialize() {
        this.initStaticController();
        new ADVCakeService('land');
        this.initSubscribeForm();
        this.initSearchFormController();
    }
}

$(() => {
    new Controller({
        el: 'body',
    });
});
